import { createSlice } from '@reduxjs/toolkit';
import {
    ultimoMeteorologico,
} from '../actions/ultimoMeteorologico';


export const UltimoMeteorologicoReducerNodo = createSlice({
    name: 'ultimoMeteorologico',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(ultimoMeteorologico.pending, (state) => { state.loading = true })
            .addCase(ultimoMeteorologico.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(ultimoMeteorologico.rejected, (state) => { state.loading = false })
    }
})

export default UltimoMeteorologicoReducerNodo.reducer;
